import { takeEvery, call, put } from "redux-saga/effects";
import {
    createDepartmentTypeApi,
    deleteDepartmentTypeApi,
    getAllDepartmentTypesApi,
    getDepartmentTypeByIdApi,
    updateDepartmentTypeApi,
} from "../api";

import {
    GET_ALL_DEPARTMENT_TYPES,
    GET_DEPARTMENT_TYPES_BY_ID,
    CREATE_DEPARTMENT_TYPES,
    UPDATE_DEPARTMENT_TYPES,
    DELETE_DEPARTMENT_TYPES,
} from "../storeTypes";

import {
    departmentTypesFailure,
    getAllDepartmentTypesSuccess,
    getDepartmentDataByIdSuccess,
    createDepartmentTypesSuccess,
    updateDepartmentTypesSuccess,
    deleteDepartmentTypesSuccess,
} from "../actions/departmentAction";

/* ===================== WORKERS ===================== */

function* getAllDepartmentTypesSaga() {
    try {
        const response = yield call(getAllDepartmentTypesApi);
        yield put(getAllDepartmentTypesSuccess(response.data.data));
    } catch (error) {
        yield put(departmentTypesFailure(error.message));
    }
}

function* getDepartmentTypeByIdSaga({ payload }) {
    try {
        const response = yield call(getDepartmentTypeByIdApi, payload);
        yield put(getDepartmentDataByIdSuccess(response.data.data));
    } catch (error) {
        yield put(departmentTypesFailure(error.message));
    }
}

function* createDepartmentTypeSaga({ payload }) {
    try {
        const response = yield call(createDepartmentTypeApi, payload);
        yield put(createDepartmentTypesSuccess(response.data.data));
    } catch (error) {
        yield put(departmentTypesFailure(error.message));
    }
}

function* updateDepartmentTypeSaga({ payload }) {
    try {
        const { id, data } = payload;
        const response = yield call(updateDepartmentTypeApi, id, data);
        yield put(updateDepartmentTypesSuccess(response.data.data));
    } catch (error) {
        yield put(departmentTypesFailure(error.message));
    }
}

function* deleteDepartmentTypeSaga({ payload }) {
    try {
        yield call(deleteDepartmentTypeApi, payload);
        yield put(deleteDepartmentTypesSuccess(payload)); // send ID only
    } catch (error) {
        yield put(departmentTypesFailure(error.message));
    }
}

/* ===================== WATCHER ===================== */

export function* departmentTypesSaga() {
    yield takeEvery(GET_ALL_DEPARTMENT_TYPES, getAllDepartmentTypesSaga);
    yield takeEvery(GET_DEPARTMENT_TYPES_BY_ID, getDepartmentTypeByIdSaga);
    yield takeEvery(CREATE_DEPARTMENT_TYPES, createDepartmentTypeSaga);
    yield takeEvery(UPDATE_DEPARTMENT_TYPES, updateDepartmentTypeSaga);
    yield takeEvery(DELETE_DEPARTMENT_TYPES, deleteDepartmentTypeSaga);
}

